import { useAppSelector } from '../../../../store/hooks';
import { MandantModel } from '../../../mandant/models/mandant.model';
import { getMandantsSelector } from '../../store/selectors/get-mandants/get-mandants.selector';

export const useGetMandants = (): MandantModel[] | null => {
  return useAppSelector(getMandantsSelector);
};
